import { useParams } from 'react-router-dom';
import { useMemo } from 'react';
import { UUID } from '../../../../../types/shared/UUID';
import { useListSigningAppointmentsQuery } from '../../../../../API/order/signingAppointment/SigningAppointmentAPI';

// a given order may have SigningAppointments, which in turn may have SigningAppointmentDocuments
// this hook returns a set of the standardDocumentIds of those SADs of a given order
export const useGetSetOfAllSigningAppointmentDocuments = (): Set<UUID> => {
  const { orderId } = useParams<{ orderId: UUID }>();
  const { data: signingAppointments = [] } = useListSigningAppointmentsQuery({ orderId });
  return useMemo(
    () =>
      new Set<UUID>(
        signingAppointments.map(({ documents }) => documents.map(({ standardDocument }) => standardDocument.id)).flat()
      ),
    [signingAppointments]
  );
};
